import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import {
  addTechnique,
  updateTechnique,
} from "../../../services/techniquesServices";
import Button from "../../../components/Button/Button";
import { toast } from "react-toastify";

const TechniqueModal = ({ isOpen, setIsOpen, technique, refresh }) => {
  const [formData, setFormData] = useState({
    nom: "",
    famille: "",
    ceinture: "",
    image1_url: "",
    video_url: "",
    traduction: "",
    information: "",
  });

  useEffect(() => {
    if (technique) {
      setFormData({
        nom: technique.nom || "",
        famille: technique.famille || "",
        ceinture: technique.ceinture || "",
        image1_url: technique.image1_url || "",
        video_url: technique.video_url || "",
        traduction: technique.traduction || "",
        information: technique.information || "",
      });
    }
  }, [technique]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (technique) {
        await updateTechnique(technique.id, formData);
        toast.success("Technique mise à jour avec succès");
      } else {
        await addTechnique(formData);
        toast.success("Technique ajoutée avec succès");
      }
      refresh();
      setIsOpen(false);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la technique", error);
      toast.error("Erreur lors de la mise à jour de la technique");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-slate-200 dark:bg-slate-400 p-4 rounded-lg shadow-lg w-[90%] max-w-md">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          {technique ? "Modifier" : "Ajouter"} une Technique
        </h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="nom"
            placeholder="Nom de la technique"
            value={formData.nom}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
            required
          />

          <select
            name="famille"
            className="select select-bordered w-full mb-3 dark:bg-gray-200 dark:text-black"
            value={formData.famille}
            onChange={handleChange}
            required
          >
            <option value="">Sélectionner une famille</option>
            <option>Jambe</option>
            <option>Hanche</option>
            <option>Epaule</option>
            <option>Bras</option>
            <option>Sutemi Waza</option>
            <option>Immobilisation</option>
            <option>Shime Waza</option>
            <option>Kansetsu-Waza</option>
            <option>Self Défense</option>
            <option>Kata</option>
            <option>Vocabulaire</option>
            <option>Les Bases</option>
            <option>Ukemi</option>
          </select>

          <select
            name="ceinture"
            className="select select-bordered w-full mb-3 dark:bg-gray-200 dark:text-black"
            value={formData.ceinture}
            onChange={handleChange}
            required
          >
            <option value="">Sélectionner une ceinture</option>
            <option>Blanche</option>
            <option>Jaune</option>
            <option>Orange</option>
            <option>Verte</option>
            <option>Bleue</option>
            <option>Marron</option>
            <option>Noire</option>
            <option>1er Dan</option>
            <option>2ème Dan</option>
            <option>3ème Dan</option>
            <option>4ème Dan</option>
            <option>5ème Dan</option>
            <option>6ème Dan</option>
            <option>7ème Dan</option>
          </select>

          <input
            type="text"
            name="image1_url"
            placeholder="URL de l'image"
            value={formData.image1_url}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
          />
          <input
            type="text"
            name="video_url"
            placeholder="URL de la vidéo"
            value={formData.video_url}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
          />
          <input
            type="text"
            name="traduction"
            placeholder="Traduction de la technique"
            value={formData.traduction}
            onChange={handleChange}
            className="input input-bordered w-full mb-3"
          />
          <textarea
            name="information"
            placeholder="Informations sur la technique"
            value={formData.information}
            onChange={handleChange}
            className="textarea textarea-bordered w-full mb-3"
          ></textarea>

          <div className="flex justify-center space-x-2 mt-4">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={() => setIsOpen(false)}
              type="button"
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default TechniqueModal;
